export default __webpack_public_path__ + "static/media/node_proj_structure.85d6c4eb.PNG";